// first: tokens (theme.css), base styles and the window shell, so each component's own CSS (imported with it) comes after
import "./ui/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App.tsx";
import { CrashBoundary } from "./ui/CrashScreen.tsx";
import { installCrashCapture } from "./lib/crash.ts";
import { captureVia } from "./lib/via.ts";

// recent console errors for a crash report (memory only; nothing is sent unless the person presses Send on the crash screen)
installCrashCapture();
// where the visitor came from, if mc-planner.com's link said (lib/via.ts): kept for this tab, out of the address bar
captureVia();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CrashBoundary>
      <App />
    </CrashBoundary>
  </StrictMode>,
);

// test/debug hook: open the app with ?debug to inspect state from the console / automated tests
// (remembered for the tab, so it survives the sign-in redirect)
const debug = (() => {
  try {
    if (new URLSearchParams(location.search).has("debug")) sessionStorage.setItem("mcp-debug", "1");
    return sessionStorage.getItem("mcp-debug") === "1";
  } catch { return false; }
})();
if (import.meta.env.DEV || debug) {
  void Promise.all([import("./state/store.ts"), import("./app/controller.ts"), import("./plan/PlanSession.ts"), import("./lib/auth.ts"), import("./lib/collab.ts"), import("./lib/billing.ts"), import("./lib/updater.ts")]).then(([s, c, ps, auth, collab, billing, updater]) => {
    (window as unknown as { __mcp: unknown }).__mcp = { useApp: s.useApp, controller: c.controller, idle: ps.IDLE, account: auth.useAccount, auth, openSignIn: auth.openSignIn, collab, billing, updater };
  });
}
